import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';

/** STEP 2-P7-H · Putaway UI (REUSE POST /operator/putaway). */
export default function OperatorPutaway({ warehouseId }) {
  const [locations, setLocations] = useState([]);
  const [f, setF] = useState({
    location_id: '', seller_id: '', product_id: '',
    variant_key: 'default', quantity: 1 });
  const [unlocated, setUnlocated] = useState(null);
  useEffect(() => {
    if (!warehouseId) return;
    (async () => {
      try {
        const r = await api.get('/operator/warehouse-locations',
                                 { params: { warehouse_id: warehouseId } });
        setLocations(r.data.items || []);
      } catch (e) {}
    })();
  }, [warehouseId]);

  const refreshUnlocated = async () => {
    if (!f.seller_id || !f.product_id) return;
    try {
      const r = await api.get('/operator/inventory-locations',
        { params: { seller_id: f.seller_id, product_id: f.product_id,
                     variant_key: f.variant_key || 'default',
                     warehouse_id: warehouseId } });
      setUnlocated(r.data);
    } catch {}
  };

  const submit = async () => {
    if (!f.location_id) return toast.error('Location 을 선택해주세요.');
    if (!f.seller_id || !f.product_id)
      return toast.error('Seller / Product 를 입력해주세요.');
    const qty = Math.max(1, Number(f.quantity) || 0);
    try {
      const r = await api.post('/operator/putaway', { ...f, quantity: qty });
      toast.success(`적치 완료 · +${r.data.quantity_placed}`);
      refreshUnlocated();
    } catch (e) {
      const s = e?.response?.status;
      if (s === 403) toast.error('이 작업을 처리할 권한이 없습니다.');
      else if (s === 409) toast.error(e?.response?.data?.detail
        || '미적치 재고보다 많이 적치할 수 없습니다.');
      else toast.error(e?.response?.data?.detail || '적치 실패');
    }
  };

  return (
    <div data-testid="operator-putaway">
      <h1 className="text-lg font-semibold mb-3">적치 (Putaway)</h1>
      <div className="bg-white border border-black/10 rounded-md p-4 space-y-2 max-w-xl">
        <label className="flex items-center gap-2 text-sm">
          <span className="w-24 text-neutral-600">Location</span>
          <select value={f.location_id}
                   onChange={(e) => setF({ ...f, location_id: e.target.value })}
                   data-testid="putaway-location-select"
                   className="flex-1 border rounded px-2 py-1 text-sm">
            <option value="">-- 선택 (수동 fallback) --</option>
            {locations.filter((l) => l.is_active).map((l) => (
              <option key={l.location_id} value={l.location_id}>
                {l.code}{l.label ? ` · ${l.label}` : ''} ({l.location_type})
              </option>
            ))}
          </select>
        </label>
        <input placeholder="Location barcode 스캔"
                data-testid="putaway-location-scan"
                onKeyDown={(e) => {
                  if (e.key !== 'Enter') return;
                  const code = (e.currentTarget.value || '').trim();
                  const hit = locations.find((l) => l.barcode === code && l.is_active);
                  if (hit) { setF({ ...f, location_id: hit.location_id });
                             toast.success(`Location ${hit.code} 선택`); }
                  else toast.error('일치하는 Location barcode 가 없습니다.');
                  e.currentTarget.value = '';
                }}
                className="w-full border rounded px-2 py-1 text-sm" />
        <Row label="Seller"   val={f.seller_id}    testid="putaway-seller"
              on={(v) => setF({ ...f, seller_id: v })} />
        <Row label="Product"  val={f.product_id}   testid="putaway-product"
              on={(v) => { setF({ ...f, product_id: v }); }} />
        <Row label="Variant"  val={f.variant_key}  testid="putaway-variant"
              on={(v) => setF({ ...f, variant_key: v })} />
        <Row label="Quantity" val={f.quantity}     testid="putaway-quantity"
              type="number" on={(v) => setF({ ...f, quantity: v })} />
        <div className="flex gap-2">
          <button onClick={refreshUnlocated} className="px-3 py-2 border rounded text-sm"
                   data-testid="putaway-refresh">
            미적치 재고 확인
          </button>
          <button onClick={submit} className="px-3 py-2 bg-[#FF3B30] text-white rounded text-sm"
                   data-testid="putaway-submit">
            적치 처리
          </button>
        </div>
        {unlocated && (
          <div className="mt-3 text-sm border-t pt-2" data-testid="putaway-unlocated">
            총 재고 {unlocated.total_stock} · 적치 {unlocated.located_stock} · 미적치 <b>{unlocated.unlocated_stock}</b>
          </div>
        )}
      </div>
    </div>
  );
}

function Row({ label, val, on, testid, type }) {
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="w-24 text-neutral-600">{label}</span>
      <input type={type || 'text'} value={val}
              onChange={(e) => on(e.target.value)}
              data-testid={testid}
              className="flex-1 border rounded px-2 py-1 text-sm" />
    </label>
  );
}
